import React, { ChangeEvent, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import InputMask from 'react-input-mask';
import { useLocation, useParams } from 'react-router-dom';
import Spinner from '../../../shared/spinner';
import { Button } from 'react-bootstrap';
import { Produto } from '../../../shared/model/produto';
import { ProdutoIdadeCartao } from '../../../shared/model/produtoIdadeCartao';
import { ProdutoIdadeSaque } from '../../../shared/model/produtoIdadeSaque';
import { ProdutoIdadeCompra } from '../../../shared/model/produtoIdadeCompra';
import { EsteiraModelo } from '../../../shared/model/esteira_modelo';
import ProdutoService from '../../../services/produtoService';
import EsteiraModeloService from '../../../services/esteiraModeloService';
import CustomAlert from '../../../shared/customAlert';
import { useVerificaPermissao } from '../../../shared/useVerificaPermissao';
import { EnumTipoProduto, TiposProduto } from '../../../shared/constantes/tiposProduto';
import ParametrosService from '../../../services/parametrosService';
import { ProdutoIdadeEmprestimo } from '../../../shared/model/produtoIdadeEmprestimo';

export const formatarMoeda = (valor?: number | null) => {
  if (valor === null || valor === undefined) return '';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(valor);
};

export const parseMoedaParaNumber = (valor: string): number => {
  const limpo = valor.replace(/\D/g, '');
  return limpo ? Number(limpo) / 100 : 0;
};

export const formatarPorcentagem = (valor?: number | null) => {
  if (valor === null || valor === undefined) return '';
  return new Intl.NumberFormat('pt-BR', {

  }).format(valor);
};

export const parsePorcentagemParaNumber = (valor: string): number => {
  if (!valor) return 0;

  const limpo = valor.replace(/[^\d,]/g, '');

  const normalizado = limpo.replace(',', '.');

  const numero = Number(normalizado);

  return isNaN(numero) ? 0 : numero;
};


const perfil = process.env.REACT_APP_PERFIL

function ProdutoInclusaoAlteracao() {
  useVerificaPermissao();
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
  const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
  const location = useLocation();
  const { id } = location.state || {};
  const { tipo } = useParams();

  const tipoProd = TiposProduto;

  const tipoValidarPor = [
    { value: 'CPF + Matr', label: 'CPF + Matr' },
    { value: 'CPF', label: 'CPF' },
  ];

  const tipoValidaBanco = [
    { value: 'Sim', label: 'Sim' },
    { value: 'Não', label: 'Não' },
  ];

  const tipoIof = [
    { value: 'IOF', label: 'IOF' },
    // { value: 'Isento', label: 'Isento' },
  ];

  const tipoFinancia = [
    { value: 'Sim', label: 'Sim' },
    // { value: 'Não', label: 'Não' },
  ];

  const tipoCalculaDV = [
    { value: 'Sim', label: 'Sim' },
    { value: 'Não', label: 'Não' },
  ];

  const tipoConsistirIdade = [
    { value: 'Data Base', label: 'Data Base' },
    { value: 'Data de Vencimento', label: 'Data de Vencimento' },
  ];

  const [nome, setNome] = useState('');
  const [tipoProduto, setTipoProduto] = useState(tipoProd[0].value);
  const [esteiras, setEsteiras] = useState<EsteiraModelo[]>([]);
  const [esteira, setEsteira] = useState('');
  const [horaCorte, setHoraCorte] = useState('');
  const [validaBanco, setValidaBanco] = useState(tipoValidaBanco[0].value);
  const [valorMinLimite, setValorMinLimite] = useState<number | null>(null);
  const [qtdContratos, setQtdContratos] = useState('');
  const [validarPor, setValidarPor] = useState(tipoValidarPor[0].value);
  const [faixaIdade1, setFaixaIdade1] = useState('');
  const [faixaIdade2, setFaixaIdade2] = useState('');
  const [iof, setIof] = useState(tipoIof[0].value);
  const [financia, setFinancia] = useState(tipoFinancia[0].value);
  const [prefixo, setPrefixo] = useState('');
  const [mascara, setMascara] = useState('');
  const [calculaDV, setCalculaDV] = useState(tipoCalculaDV[0].value);
  const [percentCompra, setPercentCompra] = useState('');
  const [percentSaque, setPercentSaque] = useState('');
  const [limiteSaque1, setLimiteSaque1] = useState('');
  const [limiteSaque2, setLimiteSaque2] = useState('');
  const [codigoMotor, setCodigoMotor] = useState('');
  const [consisteIdadeSaque, setConsisteIdadeSaque] = useState(tipoConsistirIdade[0].value);

  const [limiteIdadeCartao, setLimiteIdadeCartao] = useState('');
  const [prazoMaximo, setPrazoMaximo] = useState('');
  const [fatorMultiplicadorRMCCartao, setFatorMultiplicadorRMCCartao] = useState('1');
  const [valorMaximoLimiteCartao, setValorMaximoLimiteCartao] = useState('');
  const [tabelaIdadeCartao, setTabelaIdadeCartao] = useState<ProdutoIdadeCartao[]>([]);

  const [limiteIdadeSaque, setLimiteIdadeSaque] = useState('');
  const [valorMaximoSaque, setValorMaximoSaque] = useState('');
  const [prazoMaximoSaque, setPrazoMaximoSaque] = useState('');
  const [fatorMultiplicadorRMCSaque, setFatorMultiplicadorRMCSaque] = useState('');
  const [tabelaIdadeSaque, setTabelaIdadeSaque] = useState<ProdutoIdadeSaque[]>([]);

  const [limiteIdadeCompra, setLimiteIdadeCompra] = useState('');
  const [valorMaximoCompra, setValorMaximoCompra] = useState('');
  const [prazoMaximoCompra, setPrazoMaximoCompra] = useState('');
  const [fatorMultiplicadorRMCCompra, setFatorMultiplicadorRMCCompra] = useState('');
  const [tabelaIdadeCompra, setTabelaIdadeCompra] = useState<ProdutoIdadeCompra[]>([]);

  const [loading, setLoading] = useState(false);
  const [backoffice, setBackoffice] = useState('');
  const [codTipoLiberacao, setCodTipoLiberacao] = useState('');
  const [codTipoQuitacao, setCodTipoQuitacao] = useState('');

  const [valorMinContratado, setValorMinContratado] = useState<number | null>(null);
  const [valorMinParcela, setValorMinParcela] = useState<number | null>(null);
  const [valorMaxParcela, setValorMaxParcela] = useState<number | null>(null);

  const [percentMargem, setPercentMargem] = useState<number | null>(null);

  const [idadeMaximaEmprestimo, setIdadeMaximaEmprestimo] = useState('');
  const [prazoMaximoEmprestimo, setPrazoMaximoEmprestimo] = useState('');
  const [valorMaximoContratadoEmp, setValorMaximoContratadoEmp] = useState('');
  const [valorMinSaldoDevedor, setValorMinSaldoDevedor] = useState('');
  const [valorMaxSaldoDevedor, setValorMaxSaldoDevedor] = useState('');

  const [tabelaIdadeEmprestimo, setTabelaIdadeEmprestimo] = useState<ProdutoIdadeEmprestimo[]>([]);


  const produtoService: ProdutoService = new ProdutoService();
  const esteiraModeloService: EsteiraModeloService = new EsteiraModeloService();
  const parametrosService: ParametrosService = new ParametrosService();

  const listarEsteiras = async () => {
    try {
      const response = await esteiraModeloService.listarEsteirasModeloAtivas();
      setEsteiras(response.data);
    } catch (err) {
      console.error(err);
    }
  };

  const adicionarDadoTabelaIdadeCartao = () => {

    if (!fatorMultiplicadorRMCCartao || !limiteIdadeCartao || !valorMaximoLimiteCartao || !prazoMaximo) {
      setAlert({ message: 'Preencha todos os campos da tabela de idade de cartão!', type: 'warning' });
      return;
    }
    /*
    if (tabelaIdadeCartao.some(item => item.idadeMaxima.toString() === limiteIdadeCartao)) {
      setAlert({ message: 'Já existe um registro com esta idade', type: 'warning' });
      return;
    }*/
    let tabelaIdad: ProdutoIdadeCartao = new ProdutoIdadeCartao();
    tabelaIdad.fatorRMC = parseInt(fatorMultiplicadorRMCCartao!);
    tabelaIdad.idadeMaxima = parseInt(limiteIdadeCartao!);
    tabelaIdad.prazoMaximo = parseInt(prazoMaximo);
    tabelaIdad.valorMaximo = parseFloat(
      valorMaximoLimiteCartao.replace(/\./g, '').replace(',', '.')
    );
    setTabelaIdadeCartao([...tabelaIdadeCartao, tabelaIdad]);
    setLimiteIdadeCartao('');
    setPrazoMaximo('');
    setFatorMultiplicadorRMCCartao('1');
    setValorMaximoLimiteCartao('');
  }
  const adicionarDadoTabelaIdadeSaque = () => {

    if (!limiteIdadeSaque || !valorMaximoSaque || !prazoMaximoSaque) {
      setAlert({ message: 'Preencha todos os campos da tabela de idade de saque!', type: 'warning' });
      return;
    }
    if (tabelaIdadeSaque.some(item => item.idadeMaxima.toString() === limiteIdadeSaque)) {
      setAlert({ message: 'Já existe um registro com esta idade', type: 'warning' });
      return;
    }

    let tabelaIdad: ProdutoIdadeSaque = new ProdutoIdadeSaque();
    tabelaIdad.idadeMaxima = parseInt(limiteIdadeSaque!);
    tabelaIdad.prazoMaximo = parseInt(prazoMaximoSaque);
    tabelaIdad.valorMaximo = parseFloat(valorMaximoSaque.replace(/\./g, '').replace(',', '.')
    );
    if (fatorMultiplicadorRMCSaque === '') {
      tabelaIdad.fatorRMC = 0;
    } else {
      tabelaIdad.fatorRMC = parseFloat(fatorMultiplicadorRMCSaque.replace(',', '.'));
    }

    setTabelaIdadeSaque([...tabelaIdadeSaque, tabelaIdad]);
    setLimiteIdadeSaque('');
    setPrazoMaximoSaque('');
    setValorMaximoSaque('');
    setFatorMultiplicadorRMCSaque('');
  };

  const adicionarDadoTabelaIdadeCompra = () => {

    if (!limiteIdadeCompra || !valorMaximoCompra) {
      setAlert({ message: 'Preencha todos os campos da tabela de idade de compra!', type: 'warning' });
      return;
    }
    if (tabelaIdadeCompra.some(item => item.idadeMaxima.toString() === limiteIdadeCompra)) {
      setAlert({ message: 'Já existe um registro com esta idade', type: 'warning' });
      return;
    }

    let tabelaIdad: ProdutoIdadeCompra = new ProdutoIdadeCompra();
    tabelaIdad.idadeMaxima = parseInt(limiteIdadeCompra!);
    tabelaIdad.prazoMaximo = parseInt(prazoMaximoCompra) || 1;
    tabelaIdad.valorMaximo = parseFloat(valorMaximoCompra.replace(/\./g, '').replace(',', '.'));
    if (fatorMultiplicadorRMCCompra === '') {
      tabelaIdad.fatorRMC = 0;
    } else {
      tabelaIdad.fatorRMC = parseFloat(fatorMultiplicadorRMCCompra.replace(',', '.'));
    }

    setTabelaIdadeCompra([...tabelaIdadeCompra, tabelaIdad]);
    setLimiteIdadeCompra('');
    setPrazoMaximoCompra('');
    setValorMaximoCompra('');
    setFatorMultiplicadorRMCCompra('');
  };

  const adicionarDadoTabelaEmprestimo = () => {

    if (
      !idadeMaximaEmprestimo ||
      !prazoMaximoEmprestimo ||
      !valorMaximoContratadoEmp ||
      !valorMinSaldoDevedor ||
      !valorMaxSaldoDevedor
    ) {
      setAlert({
        message: 'Preencha todos os campos da tabela de parâmetros de empréstimo!',
        type: 'warning',
      });
      return;
    }

    if (
      tabelaIdadeEmprestimo.some(
        item => item.idadeMaxima.toString() === idadeMaximaEmprestimo
      )
    ) {
      setAlert({
        message: 'Já existe um registro com esta idade máxima!',
        type: 'warning',
      });
      return;
    }

    let tabelaEmp: ProdutoIdadeEmprestimo = new ProdutoIdadeEmprestimo();

    tabelaEmp.idadeMaxima = parseInt(idadeMaximaEmprestimo);
    tabelaEmp.prazoMaximo = parseInt(prazoMaximoEmprestimo);

    tabelaEmp.valorMaximoContratado = parseFloat(
      valorMaximoContratadoEmp.replace(/\./g, '').replace(',', '.')
    );

    tabelaEmp.valorMinSaldoDevedor = parseFloat(
      valorMinSaldoDevedor.replace(/\./g, '').replace(',', '.')
    );

    tabelaEmp.valorMaxSaldoDevedor = parseFloat(
      valorMaxSaldoDevedor.replace(/\./g, '').replace(',', '.')
    );

    setTabelaIdadeEmprestimo([...tabelaIdadeEmprestimo, tabelaEmp]);

    setIdadeMaximaEmprestimo('');
    setPrazoMaximoEmprestimo('');
    setValorMaximoContratadoEmp('');
    setValorMinSaldoDevedor('');
    setValorMaxSaldoDevedor('');
  };

  const removerDadoTabelaIdadeCartao = (index: number) => {
    const newTabelaIdade = [...tabelaIdadeCartao];
    newTabelaIdade.splice(index, 1);
    setTabelaIdadeCartao(newTabelaIdade);
  };

  const removerDadoTabelaIdadeSaque = (index: number) => {
    const newTabelaIdade = [...tabelaIdadeSaque];
    newTabelaIdade.splice(index, 1);
    setTabelaIdadeSaque(newTabelaIdade);
  };

  const removerDadoTabelaIdadeCompra = (index: number) => {
    const newTabelaIdade = [...tabelaIdadeCompra];
    newTabelaIdade.splice(index, 1);
    setTabelaIdadeCompra(newTabelaIdade);
  };

  const removerDadoTabelaEmprestimo = (index: number) => {
    const newTabelaIdade = [...tabelaIdadeEmprestimo];
    newTabelaIdade.splice(index, 1);
    setTabelaIdadeEmprestimo(newTabelaIdade);
  };

  const listarProdutoPorId = async () => {
    setLoading(true);
    try {
      const response = await produtoService.listarProdutoPorId(id);
      const jsonProduto = response.data;
      console.log('Dados recebidos do backend:', jsonProduto)
      setNome(jsonProduto.nome);
      setTipoProduto(jsonProduto.tipoProduto);
      setEsteira(jsonProduto.esteira.id!.toString());
      setHoraCorte(jsonProduto.horaCorte);
      setValidaBanco(jsonProduto.validaBanco ? 'Sim' : 'Não');
      setValorMinLimite(jsonProduto.valorMinLimite);
      setQtdContratos(jsonProduto.qtdContratos);
      setValidarPor(jsonProduto.validarPor);
      setFaixaIdade1(jsonProduto.faixaIdade1);
      setFaixaIdade2(jsonProduto.faixaIdade2);
      setIof(jsonProduto.iof);
      setFinancia(jsonProduto.financia ? 'Sim' : 'Não');
      setPrefixo(jsonProduto.prefixo);
      setMascara(jsonProduto.mascara);
      setCalculaDV(jsonProduto.calculaDV ? 'Sim' : 'Não');
      setPercentCompra(String(jsonProduto.percentCompra));
      setPercentSaque(String(jsonProduto.percentSaque));
      setLimiteSaque1(String(jsonProduto.limiteSaque1));
      setLimiteSaque2(String(jsonProduto.limiteSaque2));
      setConsisteIdadeSaque(jsonProduto.consisteIdadeSaque);
      setTabelaIdadeCartao(jsonProduto.tabelaIdadeCartao || []);
      setTabelaIdadeCompra(jsonProduto.tabelaIdadeCompra || []);
      setTabelaIdadeSaque(jsonProduto.tabelaIdadeSaque || []);
      setTabelaIdadeEmprestimo(jsonProduto.tabelaIdadeEmprestimo || []);
      setValorMinContratado(jsonProduto.valorMinContratado);
      setValorMinParcela(jsonProduto.valorMinParcela);
      setValorMaxParcela(jsonProduto.valorMaxParcela);
      setPercentMargem(jsonProduto.percentMargem);
      if (perfil === 'QISTA') {
        setCodigoMotor(jsonProduto.codigoMotor.toString().padStart(6, "0"));
      } else {
        setCodigoMotor(jsonProduto.codigoMotor.toString());
      }
      setCodTipoLiberacao(jsonProduto.codigoTipoLiberacao);
      setCodTipoQuitacao(jsonProduto.codigoTipoQuitacao);


      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const limparCampos = () => {
    setNome('');
    setTipoProduto('');
    setEsteira('');
    setHoraCorte('');
    setValidaBanco('');
    setValorMinLimite(0);
    setQtdContratos('');
    setValidarPor('');
    setFaixaIdade1('');
    setFaixaIdade2('');
    setIof('');
    setFinancia('');
    setPrefixo('');
    setMascara('');
    setCalculaDV('');
    setPercentCompra('');
    setPercentSaque('');
    setLimiteSaque1('');
    setLimiteSaque2('');
    setConsisteIdadeSaque('');
    setTabelaIdadeCartao([]);
    setTabelaIdadeSaque([]);
    setTabelaIdadeCompra([]);
    setCodigoMotor('');
  };

  const formatarValorMonetario = (valor: string): string => {
    if (!valor) return '0,00';
    const valorNumerico = valor.replace(/^0+/, '') || '0';
    const valorCompleto = valorNumerico.padStart(3, '0');
    const reais = valorCompleto.slice(0, -2);
    const centavos = valorCompleto.slice(-2);
    const reaisFormatados = parseInt(reais, 10).toLocaleString('pt-BR');

    return `${reaisFormatados},${centavos}`;
  };

  const handleChangeValorMinimo = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValorMinLimite(parseMoedaParaNumber(e.target.value));
  };

  const handleChangeValorMinContratado = (e: React.ChangeEvent<HTMLInputElement>) =>
    setValorMinContratado(parseMoedaParaNumber(e.target.value));

  const handleChangeValorMinParcela = (e: React.ChangeEvent<HTMLInputElement>) =>
    setValorMinParcela(parseMoedaParaNumber(e.target.value));

  const handleChangeValorMaxParcela = (e: React.ChangeEvent<HTMLInputElement>) =>
    setValorMaxParcela(parseMoedaParaNumber(e.target.value));

  const handleChangePercentMargem = (e: React.ChangeEvent<HTMLInputElement>) => {
    const valorNumero = parsePorcentagemParaNumber(e.target.value);
    if (valorNumero > 100) {
      setPercentMargem(100);
    } else {
      setPercentMargem(valorNumero);
    }
  };

  const handleChangeValorMaximoCartao = (e: ChangeEvent<HTMLInputElement>) => {
    const valorDigitado = e.target.value.replace(/\D/g, '');
    const valorFormatado = formatarValorMonetario(valorDigitado);
    setValorMaximoLimiteCartao(valorFormatado);
  };

  const handleChangeValorMaximoContratadoEmp = (e: ChangeEvent<HTMLInputElement>) => {
    const valorDigitado = e.target.value.replace(/\D/g, '');
    const valorFormatado = formatarValorMonetario(valorDigitado);
    setValorMaximoContratadoEmp(valorFormatado);
  };

  const handleChangeValorMinSaldoDevedor = (e: ChangeEvent<HTMLInputElement>) => {
    const valorDigitado = e.target.value.replace(/\D/g, '');
    const valorFormatado = formatarValorMonetario(valorDigitado);
    setValorMinSaldoDevedor(valorFormatado);
  };

  const handleChangeValorMaxSaldoDevedor = (e: ChangeEvent<HTMLInputElement>) => {
    const valorDigitado = e.target.value.replace(/\D/g, '');
    const valorFormatado = formatarValorMonetario(valorDigitado);
    setValorMaxSaldoDevedor(valorFormatado);
  };

  const handleChangeValorMaximoSaque = (e: ChangeEvent<HTMLInputElement>) => {
    const valorDigitado = e.target.value.replace(/\D/g, '');
    const valorFormatado = formatarValorMonetario(valorDigitado);
    setValorMaximoSaque(valorFormatado);
  };

  const handleChangeValorMaximoCompra = (e: ChangeEvent<HTMLInputElement>) => {
    const valorDigitado = e.target.value.replace(/\D/g, '');
    const valorFormatado = formatarValorMonetario(valorDigitado);
    setValorMaximoCompra(valorFormatado);
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!validarCamposGerais()) return;
    if (!validarCamposPorTipoProduto()) return;

    setLoading(true);

    try {
      let produto = montarProduto();

      await produtoService.incluirAlterarProduto(produto);

      setAlert({ message: 'Operação realizada com sucesso!', type: 'success' });
      await sleep(2000);
      window.location.href = '/parametros-produto';
    } catch (err: any) {
      setLoading(false);
      setAlert({
        message: err?.response?.data || 'Erro inesperado ao salvar o produto.',
        type: 'error',
      });
      console.error(err);
    }
  };

  const montarProduto = (): Produto => {
    let produto: Produto = new Produto();
    produto.id = id;
    produto.nome = nome;
    produto.tipoProduto = tipoProduto;
    let est = new EsteiraModelo();
    est.id = esteira;
    produto.esteira = est;
    produto.horaCorte = horaCorte;
    produto.validaBanco = validaBanco === 'Sim' ? true : false;
    produto.qtdContratos = parseInt(qtdContratos);
    produto.validarPor = validarPor;
    produto.faixaIdade1 = parseInt(faixaIdade1);
    produto.faixaIdade2 = parseInt(faixaIdade2);
    produto.iof = iof;
    produto.financia = financia === 'Sim' ? true : false;
    produto.prefixo = prefixo;
    produto.mascara = mascara;
    produto.calculaDV = calculaDV === 'Sim' ? true : false;
    produto.consisteIdadeSaque = consisteIdadeSaque;

    produto.codigoMotor = parseInt(codigoMotor);
    if (backoffice === 'FUNCAO') {
      produto.codigoTipoLiberacao = parseInt(codTipoLiberacao);
      produto.codigoTipoQuitacao = parseInt(codTipoQuitacao);
    }

    produto.percentMargem = percentMargem ?? 0;
    produto.valorMinContratado = valorMinContratado ?? 0;
    produto.valorMinParcela = valorMinParcela ?? 0;
    produto.valorMaxParcela = valorMaxParcela ?? 0;
    produto.valorMinLimite = valorMinLimite ?? 0;
    produto.percentCompra = parseFloat(percentCompra);
    produto.percentSaque = parseFloat(percentSaque);
    produto.limiteSaque1 = parseFloat(limiteSaque1);
    produto.limiteSaque2 = parseFloat(limiteSaque2);

    produto.tabelaIdadeCartao = tabelaIdadeCartao;
    produto.tabelaIdadeSaque = tabelaIdadeSaque;
    produto.tabelaIdadeCompra = tabelaIdadeCompra;
    produto.tabelaIdadeEmprestimo = tabelaIdadeEmprestimo;
    return produto;
  };


  const validarCamposGerais = (): boolean => {
    if (esteira === '0' || esteira === '') {
      setAlert({ message: 'Selecione uma Esteira!', type: 'warning' });
      return false;
    }

    if (horaCorte.length !== 5) {
      setAlert({ message: 'Preencha a Hora de Corte corretamente!', type: 'warning' });
      return false;
    }

    if (mascara.length < 2) {
      setAlert({ message: 'A mascára deve ter no mínimo 2 caracteres!', type: 'warning' });
      return false;
    }

    return true;
  };

  const validarCamposPorTipoProduto = (): boolean => {
    switch (tipoProduto) {
      case EnumTipoProduto.CARTAO_BENEFICIO:
      case EnumTipoProduto.CARTAO_CREDITO:
        if (!tabelaIdadeCartao || tabelaIdadeCartao.length < 1) {
          setAlert({
            message: 'Não existe Política de Idade de Cartão cadastrada!',
            type: 'warning',
          });
          return false;
        }

        if (parseInt(faixaIdade1) > parseInt(faixaIdade2)) {
          setAlert({ message: 'Faixa de idade inválida!', type: 'warning' });
          return false;
        }
        return true;

      case EnumTipoProduto.EMPRESTIMO:
        if (!percentMargem) {
          setAlert({
            message: 'Informe o percentual de margem consignável!',
            type: 'warning',
          });
          return false;
        }

        if (!tabelaIdadeEmprestimo || tabelaIdadeEmprestimo.length < 1) {
          setAlert({
            message: 'Cadastre ao menos um parâmetro de empréstimo!',
            type: 'warning',
          });
          return false;
        }
        return true;

      default:
        return true;
    }
  };


  const listarTodosParametrosTi = async () => {
    const responseList = await parametrosService.listarTodosParametros();
    const json = responseList.data;

    setBackoffice(json.backoffice)
  }

  useEffect(() => {
    listarEsteiras();
    if (tipo === 'alteracao') {
      listarProdutoPorId();
    }
    listarTodosParametrosTi();
  }, []);

  return (
    <div className="container">
      {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={() => setAlert(null)} />)}
      {loading ? <Spinner loading={loading} /> : (
        <form onSubmit={handleSubmit}>
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
              {tipo === 'inclusao' ? <h5>Parâmetros Cartão &gt; Produtos &gt; Inclusão</h5> : (
                <h5>Parâmetros Cartão &gt; Produtos &gt; Alteração</h5>
              )}
              <Button id="App-button-cor-principal" onClick={() => window.history.back()}>
                Voltar
              </Button>
            </div>
            <hr className="my-4" />
          </div>
          <div className="row">
            {tipo === 'alteracao' ? (
              <div className="col-md-1">
                <label>Código</label>
                <input style={{ backgroundColor: 'LightGrey' }} type="text" required className="form-control" value={id} readOnly />
              </div>
            ) : null}
            <div className="col-md-4">
              <label>Nome <span style={{ color: 'red' }}>*</span></label>
              <input required type="text" className="form-control" value={nome} onChange={(e) => setNome(e.target.value)} />
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <span>Tipo de Produto <span style={{ color: 'red' }}>*</span></span>
                <select className="form-select" defaultValue={tipoProduto[0]} value={tipoProduto} onChange={(e) => setTipoProduto(e.target.value)}>
                  {tipoProd.map((item) => (
                    <option key={item.label} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-4">
              <label>Esteira <span style={{ color: 'red' }}>*</span></label>
              <select className="form-select" value={esteira} onChange={(e) => setEsteira(e.target.value)}>
                <option value="0">Selecione uma esteira</option>
                {esteiras.map((item) => (
                  <option key={item.id} value={item.id!}>
                    {item.id + ' - ' + item.nomeEsteira}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="row">
            <div className="col-md-2">
              <label>Horário Corte <span style={{ color: 'red' }}>*</span></label>
              <InputMask required mask="99:99" type="text" className="form-control" value={horaCorte} onChange={(e) => setHoraCorte((e.target.value).replace(/_/g, ""))} />
            </div>

            <div className="col-md-3">
              <label>Valida Banco Digital <span style={{ color: 'red' }}>*</span></label>
              <select className="form-select" defaultValue={validaBanco[0]} value={validaBanco} onChange={(e) => setValidaBanco(e.target.value)}>
                {tipoValidaBanco.map((item) => (
                  <option key={item.label} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-5">
              <label>Código Externo</label>
              <InputMask maskChar={null} mask="999999" type="text" className="form-control" value={codigoMotor} onChange={(e) => setCodigoMotor((e.target.value))} />
            </div>

          </div>
          <div className="row">
            {(tipoProduto === EnumTipoProduto.CARTAO_BENEFICIO || tipoProduto === EnumTipoProduto.CARTAO_CREDITO) && (
              <div className="col-md-2">
                <div className="form-group">
                  <label>Valor Mínimo de Limite <span style={{ color: 'red' }}>*</span></label>
                  <input required type="text" className="form-control" value={formatarMoeda(valorMinLimite)} onChange={(e) => handleChangeValorMinimo(e)} />
                </div>
              </div>
            )}
            <div className="col-xl">
              <label>QTD Contratos <span style={{ color: 'red' }}>*</span></label>
              <InputMask maskChar={null} required mask="99" type="text" className="form-control" value={qtdContratos} onChange={(e) => setQtdContratos((e.target.value).replace(/_/g, ""))} />
            </div>
            <div className="col-xl">
              <label>Validar Por: <span style={{ color: 'red' }}>*</span></label>
              <select className="form-select" defaultValue={validarPor} value={validarPor} onChange={(e) => setValidarPor(e.target.value)}>
                {tipoValidarPor.map((item) => (
                  <option key={item.label} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-4">
              <label>Faixa de Idade <span style={{ color: 'red' }}>*</span></label>
              <thead>
                <tr>
                  <th style={{ width: "150px" }}><InputMask required mask="99" maskChar={null} type="text" className="form-control" value={faixaIdade1} onChange={(e) => setFaixaIdade1((e.target.value).replace(/_/g, ""))} /></th>
                  <th style={{ width: "15px" }}> a </th>
                  <th style={{ width: "150px" }}><InputMask required mask="99" maskChar={null} type="text" className="form-control" value={faixaIdade2} onChange={(e) => setFaixaIdade2((e.target.value).replace(/_/g, ""))} /></th>
                </tr>
              </thead>
            </div>
          </div>

          {(tipoProduto === EnumTipoProduto.EMPRESTIMO || tipoProduto === EnumTipoProduto.ANTECIPACAO_REMUNERACAO) && (
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Valor Mínimo Contratado <span style={{ color: 'red' }}>*</span></label>
                  <input
                    required
                    type="text"
                    className="form-control"
                    value={formatarMoeda(valorMinContratado)}
                    onChange={(e) => handleChangeValorMinContratado(e)}
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>Valor Mínimo da Parcela <span style={{ color: 'red' }}>*</span></label>
                  <input
                    required
                    type="text"
                    className="form-control"
                    value={formatarMoeda(valorMinParcela)}
                    onChange={(e) => handleChangeValorMinParcela(e)}
                  />
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>Valor Máximo da Parcela <span style={{ color: 'red' }}>*</span></label>
                  <input
                    required
                    type="text"
                    className="form-control"
                    value={formatarMoeda(valorMaxParcela)}
                    onChange={(e) => handleChangeValorMaxParcela(e)}
                  />
                </div>
              </div>
            </div>
          )}

          {backoffice === 'FUNCAO' && (
            <div className="row">
              <div className="col-md-2">
                <div className="form-group">
                  <label>Código Tipo de Liberação <span style={{ color: 'red' }}>*</span></label>
                  <input required type="text" className="form-control" value={codTipoLiberacao} onChange={(e) => setCodTipoLiberacao(e.target.value)} />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>Código Tipo de Quitação <span style={{ color: 'red' }}>*</span></label>
                  <input required type="text" className="form-control" value={codTipoQuitacao} onChange={(e) => setCodTipoQuitacao(e.target.value)} />
                </div>
              </div>
            </div>
          )}
          <h6 style={{ marginTop: '20px' }}>IOF</h6>
          <div className="row">
            <div className="col-md-2">
              <label>Tipo IOF <span style={{ color: 'red' }}>*</span></label>
              <select className="form-select" defaultValue={iof} value={iof} onChange={(e) => setIof(e.target.value)}>
                {tipoIof.map((item) => (
                  <option key={item.label} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-2">
              <label>Financia <span style={{ color: 'red' }}>*</span></label>
              <select className="form-select" defaultValue={financia} value={financia} onChange={(e) => setFinancia(e.target.value)}>
                {tipoFinancia.map((item) => (
                  <option key={item.label} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <h6 style={{ marginTop: '20px' }}>Máscara do Número do Contrato</h6>
          <div className="row">
            <div className="col-md-2">
              <label>Prefixo <span style={{ color: 'red' }}>*</span></label>
              <InputMask required maskChar={null} mask="9" type="text" className="form-control" value={prefixo} onChange={(e) => setPrefixo((e.target.value).replace(/_/g, ""))} />
            </div>
            <div className="col-md-3">
              <label>Máscara <span style={{ color: 'red' }}>*</span></label>
              <InputMask required maskChar={null} mask="999999999" type="text" className="form-control" value={mascara} onChange={(e) => setMascara((e.target.value).replace(/_/g, ""))} />
            </div>
            <div className="col-md-2">
              <label>Calcula DV</label>
              <select className="form-select" defaultValue={calculaDV} value={calculaDV} onChange={(e) => setCalculaDV(e.target.value)}>
                {tipoCalculaDV.map((item) => (
                  <option key={item.label} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          {(tipoProduto === EnumTipoProduto.CARTAO_BENEFICIO || tipoProduto === EnumTipoProduto.CARTAO_CREDITO) && (
            <div>
              <h6 style={{ marginTop: '20px' }}>Parâmetros Cartão Consignado</h6>
              <div className="row">
                <div className="col-md-2">
                  <label>% Compra <span style={{ color: 'red' }}>*</span></label>
                  <InputMask maskChar={null} required mask="999" type="text" className="form-control" value={percentCompra} onChange={(e) => setPercentCompra((e.target.value).replace(/_/g, ""))} />
                </div>
                <div className="col-md-3">
                  <label>% Saque <span style={{ color: 'red' }}>*</span></label>
                  <InputMask maskChar={null} required mask="999" type="text" className="form-control" value={percentSaque} onChange={(e) => setPercentSaque((e.target.value).replace(/_/g, ""))} />
                </div>
                <div className="col-md-4">
                  <label>Limites de Saque <span style={{ color: 'red' }}>*</span></label>
                  <thead>
                    <tr>
                      <th style={{ width: "150px" }}><InputMask required mask="9999999" maskChar={null} type="text" className="form-control" value={limiteSaque1} onChange={(e) => setLimiteSaque1((e.target.value).replace(/_/g, ""))} /></th>
                      <th style={{ width: "15px" }}> a </th>
                      <th style={{ width: "150px" }}><InputMask required mask="9999999" maskChar={null} type="text" className="form-control" value={limiteSaque2} onChange={(e) => setLimiteSaque2((e.target.value).replace(/_/g, ""))} /></th>
                    </tr>
                  </thead>
                </div>
              </div>
            </div>
          )}
          {(tipoProduto === EnumTipoProduto.CARTAO_BENEFICIO || tipoProduto === EnumTipoProduto.CARTAO_CREDITO) && (
            <div>
              <h6 style={{ marginTop: '20px' }}>Política de Idade - Cartão</h6>
              <div className="row">
                <div className="col-md-2">
                  <label>Limite de Idade <span style={{ color: 'red' }}>*</span></label>
                  <InputMask maskChar={null} mask="99" type="text" className="form-control" value={limiteIdadeCartao} onChange={(e) => { setLimiteIdadeCartao((e.target.value).replace(/_/g, "")); console.log((e.target.value).replace(/_/g, "")) }} />
                </div>
                <div className="col-md-2">
                  <label>Prazo Máximo <span style={{ color: 'red' }}>*</span></label>
                  <InputMask maskChar={null} mask="99" type="text" className="form-control" value={prazoMaximo} onChange={(e) => { setPrazoMaximo((e.target.value).replace(/_/g, "")); console.log((e.target.value).replace(/_/g, "")) }} />
                </div>
                <div className="col-md-3">
                  <label>Fator Multiplicador RMC </label>
                  <text style={{ backgroundColor: 'LightGrey' }} className="form-control" display={'none'}>{fatorMultiplicadorRMCCartao}</text>
                  {/* <InputMask maskChar={null} mask="99" type="text" className="form-control" value={fatorMultiplicadorRMCCartao} onChange={(e) => { setFatorMultiplicadorRMCCartao((e.target.value).replace(/_/g, "")); console.log((e.target.value).replace(/_/g, "")) }}/> */}
                </div>
                <div className="col-md-3">
                  <label>Valor Máximo de Limite <span style={{ color: 'red' }}>*</span></label>
                  <input type="text" className="form-control" value={valorMaximoLimiteCartao} onChange={(e) => { handleChangeValorMaximoCartao(e) }} />
                </div>
                <div className="col-xl">
                  <Button style={{ backgroundColor: '#36D7B7', border: '1px solid #36D7B7', color: 'white', cursor: 'pointer', textAlign: 'center', marginTop: '20px' }}
                    onClick={() => adicionarDadoTabelaIdadeCartao()}>+
                  </Button>
                </div>
              </div>

              {tabelaIdadeCartao.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th scope="col" id="App-header-table">Idade Máxima</th>
                        <th scope="col" id="App-header-table"> Prazo Máximo</th>
                        <th scope="col" id="App-header-table">Fator RMC</th>
                        <th scope="col" id="App-header-table">Valor Máximo Limite</th>
                        <th scope="col" id="App-header-table">Excluir</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tabelaIdadeCartao.map((item, index) => (
                        <tr>
                          <td>{item.idadeMaxima}</td>
                          <td>{item.prazoMaximo}</td>
                          <td>{item.fatorRMC}</td>
                          <td>
                            {new Intl.NumberFormat('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            }).format(item.valorMaximo)}
                          </td>
                          <td>
                            <Button style={{
                              backgroundColor: '#dc3545',
                              border: '1px solid #dc3545',
                              color: 'white',
                              cursor: 'pointer',
                              textAlign: 'center',
                            }} onClick={() => removerDadoTabelaIdadeCartao(index)}>X
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : false}
            </div>
          )}
          {(tipoProduto === EnumTipoProduto.CARTAO_BENEFICIO || tipoProduto === EnumTipoProduto.CARTAO_CREDITO) && (
            <div>
              <h6 style={{ marginTop: '20px' }}>Política de Idade - Compra</h6>
              <div className="row">
                <div className="col-md-2">
                  <label>Limite de Idade <span style={{ color: 'red' }}>*</span></label>
                  <InputMask maskChar={null} mask="99" type="text" className="form-control" value={limiteIdadeCompra} onChange={(e) => { setLimiteIdadeCompra((e.target.value).replace(/_/g, "")); console.log((e.target.value).replace(/_/g, "")) }} />
                </div>
                <div className="col-md-2">
                  <label>Prazo Máximo <span style={{ color: 'red' }}>*</span></label>
                  <text style={{ backgroundColor: 'LightGrey' }} className="form-control" >{1}</text>
                </div>
                <div className="col-md-3">
                  <label>Fator Multiplicador RMC </label>
                  <input
                    type="text"
                    className="form-control"
                    value={fatorMultiplicadorRMCCompra}
                    onChange={(e) => setFatorMultiplicadorRMCCompra(e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <label>Valor Máximo de Limite <span style={{ color: 'red' }}>*</span></label>
                  <input type="text" className="form-control" value={valorMaximoCompra} onChange={(e) => { handleChangeValorMaximoCompra(e) }} />
                </div>
                <div className="col-xl">
                  <Button style={{ backgroundColor: '#36D7B7', border: '1px solid #36D7B7', color: 'white', cursor: 'pointer', textAlign: 'center', marginTop: '20px' }}
                    onClick={() => adicionarDadoTabelaIdadeCompra()}>+
                  </Button>
                </div>
              </div>

              {tabelaIdadeCompra.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th scope="col" id="App-header-table">Idade Máxima</th>
                        <th scope="col" id="App-header-table"> Prazo Máximo</th>
                        <th scope="col" id="App-header-table">Fator RMC</th>
                        <th scope="col" id="App-header-table">Valor Máximo Limite</th>
                        <th scope="col" id="App-header-table">Excluir</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tabelaIdadeCompra.map((item, index) => (
                        <tr>
                          <td>{item.idadeMaxima}</td>
                          <td>{item.prazoMaximo}</td>
                          <td>{item.fatorRMC == 0 ? "" : item.fatorRMC}</td>
                          <td>
                            {new Intl.NumberFormat('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            }).format(item.valorMaximo)}
                          </td>
                          <td>
                            <Button style={{
                              backgroundColor: '#dc3545',
                              border: '1px solid #dc3545',
                              color: 'white',
                              cursor: 'pointer',
                              textAlign: 'center',
                            }} onClick={() => removerDadoTabelaIdadeCompra(index)}>X
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : false}
            </div>
          )}
          {(tipoProduto === EnumTipoProduto.CARTAO_BENEFICIO || tipoProduto === EnumTipoProduto.CARTAO_CREDITO) && (
            <div>
              <h6 style={{ marginTop: '20px' }}>Política de Idade - Saque</h6>
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Consistir Idade em: <span style={{ color: 'red' }}>*</span></label>
                    <select className="form-select" defaultValue={consisteIdadeSaque} value={consisteIdadeSaque} onChange={(e) => setConsisteIdadeSaque(e.target.value)}>
                      {tipoConsistirIdade.map((item) => (
                        <option key={item.label} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-2">
                  <label>Limite de Idade <span style={{ color: 'red' }}>*</span></label>
                  <InputMask maskChar={null} mask="99" type="text" className="form-control" value={limiteIdadeSaque} onChange={(e) => setLimiteIdadeSaque((e.target.value).replace(/_/g, ""))} />
                </div>
                <div className="col-md-2">
                  <label>Prazo Máximo <span style={{ color: 'red' }}>*</span></label>
                  <InputMask maskChar={null} mask="99" type="text" className="form-control" value={prazoMaximoSaque} onChange={(e) => { setPrazoMaximoSaque((e.target.value).replace(/_/g, "")); console.log((e.target.value).replace(/_/g, "")) }} />
                </div>
                <div className="col-md-3">
                  <label>Fator Multiplicador RMC </label>
                  <input
                    type="text"
                    className="form-control"
                    value={fatorMultiplicadorRMCSaque}
                    onChange={(e) => setFatorMultiplicadorRMCSaque(e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <label>Valor Máximo de Limite <span style={{ color: 'red' }}>*</span></label>
                  <input type="text" className="form-control" value={valorMaximoSaque} onChange={(e) => handleChangeValorMaximoSaque(e)} />
                </div>
                <div className="col-xl">
                  <Button style={{ backgroundColor: '#36D7B7', border: '1px solid #36D7B7', color: 'white', cursor: 'pointer', textAlign: 'center', marginTop: '20px' }}
                    onClick={() => adicionarDadoTabelaIdadeSaque()}>+
                  </Button>
                </div>
              </div>

              {tabelaIdadeSaque.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th scope="col" id="App-header-table">Idade Máxima</th>
                        <th scope="col" id="App-header-table">Prazo Máximo</th>
                        <th scope="col" id="App-header-table">Fator RMC</th>
                        <th scope="col" id="App-header-table">Valor Máximo Limite</th>
                        <th scope="col" id="App-header-table">Excluir</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tabelaIdadeSaque.map((item, index) => (
                        <tr>
                          <td>{item.idadeMaxima}</td>
                          <td>{item.prazoMaximo}</td>
                          <td>{item.fatorRMC == 0 ? "" : item.fatorRMC}</td>
                          <td>
                            {new Intl.NumberFormat('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            }).format(item.valorMaximo)}
                          </td>
                          <td>
                            <Button style={{
                              backgroundColor: '#dc3545',
                              border: '1px solid #dc3545',
                              color: 'white',
                              cursor: 'pointer',
                              textAlign: 'center',
                            }} onClick={() => removerDadoTabelaIdadeSaque(index)}>X
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : false}
            </div>
          )}
          {tipoProduto === EnumTipoProduto.EMPRESTIMO && (
            <div>
              <h6 style={{ marginTop: '20px' }}>Parâmetros Empréstimo</h6>
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Consistir Idade em: <span style={{ color: 'red' }}>*</span></label>
                    <select className="form-select" defaultValue={consisteIdadeSaque} value={consisteIdadeSaque} onChange={(e) => setConsisteIdadeSaque(e.target.value)}>
                      {tipoConsistirIdade.map((item) => (
                        <option key={item.label} value={item.value}>
                          {item.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label>% Utiliz. Margem Consignável <span style={{ color: 'red' }}>*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={formatarPorcentagem(percentMargem)}
                      onChange={(e) => handleChangePercentMargem(e)}
                    />
                  </div>
                </div>

              </div>

              <div className="row">
                <div className="col-md-2">
                  <label>Limite de Idade <span style={{ color: 'red' }}>*</span></label>
                  <InputMask
                    maskChar={null}
                    mask="99"
                    type="text"
                    className="form-control"
                    value={idadeMaximaEmprestimo}
                    onChange={(e) =>
                      setIdadeMaximaEmprestimo(e.target.value.replace(/_/g, ''))
                    }
                  />
                </div>

                <div className="col-md-2">
                  <label>Prazo Máximo <span style={{ color: 'red' }}>*</span></label>
                  <InputMask
                    maskChar={null}
                    mask="99"
                    type="text"
                    className="form-control"
                    value={prazoMaximoEmprestimo}
                    onChange={(e) =>
                      setPrazoMaximoEmprestimo(e.target.value.replace(/_/g, ''))
                    }
                  />
                </div>

                <div className="col-md-3">
                  <label>Valor Máximo Contratado <span style={{ color: 'red' }}>*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    value={valorMaximoContratadoEmp}
                    onChange={(e) => handleChangeValorMaximoContratadoEmp(e)}
                  />
                </div>

                <div className="col-md-2">
                  <label>Valor Min. Saldo Devedor <span style={{ color: 'red' }}>*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    value={valorMinSaldoDevedor}
                    onChange={(e) => handleChangeValorMinSaldoDevedor(e)}
                  />
                </div>

                <div className="col-md-2">
                  <label>Valor Máx. Saldo Devedor <span style={{ color: 'red' }}>*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    value={valorMaxSaldoDevedor}
                    onChange={(e) => handleChangeValorMaxSaldoDevedor(e)}
                  />
                </div>

                <div className="col-xl">
                  <Button
                    style={{
                      backgroundColor: '#36D7B7',
                      border: '1px solid #36D7B7',
                      color: 'white',
                      cursor: 'pointer',
                      textAlign: 'center',
                      marginTop: '20px',
                    }}
                    onClick={adicionarDadoTabelaEmprestimo}
                  >
                    +
                  </Button>
                </div>
              </div>
              {tabelaIdadeEmprestimo.length > 0 && (
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Idade Máxima</th>
                        <th>Prazo Máximo</th>
                        <th>Valor Máx. Contratado</th>
                        <th>Valor Min. Saldo Devedor</th>
                        <th>Valor Máx. Saldo Devedor</th>
                        <th>Excluir</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tabelaIdadeEmprestimo.map((item, index) => (
                        <tr key={index}>
                          <td>{item.idadeMaxima}</td>
                          <td>{item.prazoMaximo}</td>
                          <td>
                            {new Intl.NumberFormat('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            }).format(item.valorMaximoContratado)}
                          </td>
                          <td>
                            {new Intl.NumberFormat('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            }).format(item.valorMinSaldoDevedor)}
                          </td>
                          <td>
                            {new Intl.NumberFormat('pt-BR', {
                              style: 'currency',
                              currency: 'BRL',
                            }).format(item.valorMaxSaldoDevedor)}
                          </td>
                          <td>
                            <Button
                              style={{
                                backgroundColor: '#dc3545',
                                border: '1px solid #dc3545',
                                color: 'white',
                              }}
                              onClick={() => removerDadoTabelaEmprestimo(index)}
                            >
                              X
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}

          <div>
            <hr className="my-4" />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <button onClick={limparCampos} className="w-40 btn btn-lg" id="App-button-cor-principal">Limpar Campos</button>
              <button className="w-40 btn btn-primary btn-lg btn btn-success" type="submit">{tipo !== 'inclusao' ? 'Alterar Produto' : 'Salvar Produto'}</button>
            </div>
          </div>
        </form>
      )
      }
    </div >
  );
}

export default ProdutoInclusaoAlteracao;
